import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/configuracao/';

class ConfiguracaoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }
    
    save(configuracao) {
        return axios.post(API_URL, JSON.stringify(configuracao),
        {headers: this.headers});
    }

    get(idCliente) {
        return axios.get(API_URL+idCliente, {headers: this.headers});
    }

    getConfImpFederais(idCliente) {
        return axios.get(API_URL+"getConfImpFederais/"+idCliente, {headers: this.headers});
    }

    saveConfImpFederais(confImpFederais) {
        return axios.post(API_URL+"salvarConfImpFederais", JSON.stringify(confImpFederais),
        {headers: this.headers});
    }

    deleteConfImpFederais(id) {
        return axios.post(API_URL+"deletarConfImpFederais?id="+id, null,
        {headers: this.headers});
    }

}

export default new ConfiguracaoService();